import MoneyMgmtTestTopicList from "../../extra_credit/Datasets/money_mgmt_test_topic_list";

export const summarizeTestByQuestion = (questionAnswerArr) => {
    questionAnswerArr = questionAnswerArr.sort((a, b) => 
        (a.questionNbr > b.questionNbr) ? 1 : -1);
    const topicList = MoneyMgmtTestTopicList;
    let prevQuestionNbr = "";
    let prevTopic = "";
    let questionObj = {};
    let questionArr = [];
    let topic = "";
     
    for (let i=0; i<questionAnswerArr.length; i++){
        const questionTopic = questionAnswerArr[i].questionNbr.split('-')[0];
        const questionNbr = questionAnswerArr[i].questionNbr;
        if (prevTopic !== questionTopic){
            prevTopic = questionTopic;
            const topicIndx = topicList.findIndex(elem => elem.abbrev === questionTopic);
            if (topicIndx === -1){
                topic = "Unknown Topic";
            }else{
                topic = topicList[topicIndx].testTopic;
            }
        }
        if (prevQuestionNbr !== questionNbr){
            if (prevQuestionNbr !== ""){
                questionArr.push(questionObj);
            }
            prevQuestionNbr = questionNbr;
            questionObj = {questionNbr: questionNbr, questionText: questionAnswerArr[i].text, 
                topic: topic, nbrTests: 0, partialCorrect: 0, nbrCorrect: 0, nbrWrong: 0}
        }        
        questionObj.nbrTests += 1;
        let fullyCorrect = false;
        if (+questionAnswerArr[i].correct === +questionAnswerArr[i].nbrRightAnswers){
            questionObj.nbrCorrect += 1;
            fullyCorrect = true;
        }else{
            questionObj.nbrWrong += 1;
        }
        if (+questionAnswerArr[i].correct > 0 && fullyCorrect === false){
            questionObj.partialCorrect += 1;
        }
    }
    if (prevTopic !== ""){
        questionArr.push(questionObj);
    }
    return questionArr;
}
export default summarizeTestByQuestion;